import React from 'react';
import numeral from 'numeral'
import {Circle, Popup} from 'react-leaflet'

const casesTypeColours = {
    cases:{
        hex:"#CC1034",
        multiplier:800
    },
    recovered:{
        hex:"#7dd71d",
        multiplier:1200
    },
    deaths:{
        hex:"#fb4443",
        multiplier:2000
    }
}

export const sortDate = (data) => {
    console.info(data)

    const sortedData = [...data];

    sortedData.sort((a,b) =>{
        if (a.cases > b.cases ){
           return -1;
        }
        else {
            return 1;
        }
    });
    return sortedData.splice(0,10);

}

//draw circle on Map
export const showDataOnMap = (data,casesType='cases') => {
   return data.map((country)=> (
     <Circle
     center = {[country.countryInfo.lat, country.countryInfo.long]}
     fillOpacity = {0.4}
     color={casesTypeColours[casesType].hex}
     fillColor = {casesTypeColours[casesType].hex}
     radius = {Math.sqrt(country[casesType]) * casesTypeColours[casesType].multiplier}
     >
         <Popup>
           <div className='info-container'>
               <div 
               className='info-flag'
               style={{backgroundImage :`url(${country.countryInfo.flag})`}}
               ></div>
               <div className='info_name'>{country.country}</div>
               <div className='info_confirmed'>Cases : {numeral(country.cases).format('0,0')}</div>
               <div className='info_recovered'>Recovered : {numeral(country.recovered).format('0,0')}</div>
               <div className='info_deaths'>Deaths : {numeral(country.deaths).format('0,0')} </div>
           </div>
        </Popup>
     </Circle>

   ))

}